import request from '@/utils/request'
import api from '../api'
export class Wallet {
  createWithdraw(data) {
    return request({
      url: api.wallet.createWithdraw,
      method: 'post',
      data
    })
  }

  accountRetrieve(params) {
    return request({
      url: api.wallet.accountRetrieve,
      method: 'get',
      params
    })
  }

  createDeposit(data) {
    return request({
      url: api.wallet.createDeposit,
      method: 'post',
      data
    })
  }

  transactionDetailSearch(data) {
    return request({
      url: api.wallet.transactionDetailSearch,
      method: 'post',
      data
    })
  }

  multiAccount(params) {
    return request({
      url: api.wallet.multiAccount,
      method: 'get',
      params
    })
  }

  domesticAccountInfo(params) {
    return request({
      url: api.wallet.domesticAccountInfo,
      method: 'get',
      params
    })
  }

  crossAccountInfo(params) {
    return request({
      url: api.wallet.crossAccountInfo,
      method: 'get',
      params
    })
  }

  uploadVoucher(data) {
    return request({
      url: api.wallet.uploadVoucher,
      method: 'post',
      data
    })
  }

  transactionDetailDownload(data) {
    return request({
      url: api.wallet.transactionDetailDownload,
      method: 'post',
      data
    })
  }

  banks(params) {
    return request({
      url: api.wallet.banks,
      method: 'get',
      params
    })
  }

  domesticReceivable(params) {
    return request({
      url: api.wallet.domesticReceivable,
      method: 'get',
      params
    })
  }

  overseasAccountAdd(data) {
    return request({
      url: api.wallet.overseasAccountAdd,
      method: 'post',
      data
    })
  }

  overseasAccountList(data) {
    return request({
      url: api.wallet.overseasAccountList,
      method: 'post',
      data
    })
  }

  overseasAccountItem(params) {
    return request({
      url: api.wallet.overseasAccountItem,
      method: 'get',
      params
    })
  }

  fillUploadBc(data) {
    return request({
      url: api.wallet.fillUploadBc,
      method: 'post',
      data
    })
  }

  walletByMerchant(data) {
    return request({
      url: api.wallet.walletByMerchant,
      method: 'post',
      data
    })
  }

  overseasWalletList(data) {
    return request({
      url: api.wallet.overseasWalletList,
      method: 'post',
      data
    })
  }

  findAccAmount(data) {
    return request({
      url: api.wallet.findAccAmount,
      method: 'post',
      data
    })
  }

  findAllAcc(params) {
    return request({
      url: api.wallet.findAllAcc,
      method: 'get',
      params
    })
  }

  findAccDetail(data) {
    return request({
      url: api.wallet.findAccDetail,
      method: 'post',
      data
    })
  }

  currencyOfCountryList(params) {
    return request({
      url: api.wallet.currencyOfCountryList,
      method: 'get',
      params
    })
  }

  orderTemplate(params) {
    return request({
      url: api.wallet.orderTemplate,
      method: 'get',
      params
    })
  }

  downFillFile(params) {
    return request({
      url: api.wallet.downFillFile,
      method: 'get',
      params
    })
  }

  channelCountry(params) {
    return request({
      url: api.wallet.channelCountry,
      method: 'get',
      params
    })
  }

  balancereminderCreate(data) {
    return request({
      url: api.wallet.balancereminderCreate,
      method: 'post',
      data
    })
  }

  updateRemind(data) {
    return request({
      url: api.wallet.updateRemind,
      method: 'post',
      data
    })
  }

  balancereminderItem(params) {
    return request({
      url: api.wallet.balancereminderItem,
      method: 'post',
      params
    })
  }

  offRemind(params) {
    return request({
      url: api.wallet.offRemind,
      method: 'put',
      params
    })
  }

  enabled(params) {
    return request({
      url: api.wallet.enabled,
      method: 'put',
      params
    })
  }

  overseasAccList(params) {
    return request({
      url: api.wallet.overseasAccList,
      method: 'get',
      params
    })
  }
  overseasAccRetrieve(params) {
    return request({
      url: api.wallet.overseasAccRetrieve,
      method: 'get',
      params
    })
  }
  accountDetail(data) {
    return request({
      url: api.wallet.accountDetail,
      method: 'post',
      data
    })
  }
  bankInfo(params) {
    return request({
      url: api.wallet.bankInfo,
      method: 'get',
      params
    })
  }
  create(data) {
    return request({
      url: api.wallet.create,
      method: 'post',
      data
    })
  }
  at_recharge(data) {
    return request({
      url: api.wallet.at_recharge,
      method: 'post',
      data
    })
  }
  kj_recharge(data) {
    return request({
      url: api.wallet.kj_recharge,
      method: 'post',
      data
    })
  }
  queryDepositChannelType(data) {
    return request({
      url: api.wallet.queryDepositChannelType,
      method: 'post',
      data
    })
  }
  payTransRetrieveById(params) {
    return request({
      url: api.wallet.payTransRetrieveById,
      method: 'get',
      params
    })
  }
  getB2bTransferInfo(data) {
    return request({
      url: api.wallet.getB2bTransferInfo,
      method: 'post',
      data
    })
  }
}
